import httpClient from './httpClient';

const feriadosPagoDobleService = {
  async obtenerFeriados(empresaId) {
    try {
      const response = await httpClient.get(`/feriados-pago-doble/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || [],
      };
    } catch (error) {
      console.error('Error al obtener feriados con pago doble:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener feriados con pago doble',
        data: [],
      };
    }
  },

  async agregarFeriado(empresaId, fecha, descripcion) {
    try {
      const response = await httpClient.post('/feriados-pago-doble', {
        empresa_id: empresaId,
        fecha,
        descripcion,
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Feriado guardado exitosamente',
      };
    } catch (error) {
      console.error('Error al agregar feriado con pago doble:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar feriado con pago doble',
      };
    }
  },

  async eliminarFeriado(id) {
    try {
      const response = await httpClient.delete(`/feriados-pago-doble/${id}`);
      return {
        success: true,
        message: response.data.message || 'Feriado eliminado exitosamente',
      };
    } catch (error) {
      console.error('Error al eliminar feriado con pago doble:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar feriado con pago doble',
      };
    }
  },
};

export default feriadosPagoDobleService;
